<template>
    <div class="p-4 bg-white rounded-lg">
        <div v-if="policyDetail.main_class == '2'">
            <div class="pb-2.5">
                <div class="text-16 font-medium text-a-black-555555 leading-22px">ข้อมูลกรมธรรม์</div>
                <div class="pt-4 text-12 text-a-black-484848 leading-4.5">{{policyDetail.main_class_name}}</div>
                <div class="flex justify-between pt-1.5 text-12 text-a-black-484848">
                    <div class="flex leading-4.5">
                        <div>เลขที่กรมธรรม์</div>
                        <div class="pl-4">{{policyDetail.policy_no}}</div>
                    </div>
                    <div class="text-a-orange-fe5000 underline" @click="clickClaim()">ประวัติการเคลม</div>
                </div>
            </div>
            <div class="py-4 border-t text-12 font-light text-a-black-484848 leading-4.5">
                <div class="flex justify-between">
                    <div>วันที่เริ่มคุ้มครอง</div>
                    <div>{{policyDetail.effective_date}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>วันสิ้นสุดความคุ้มครอง</div>
                    <div>{{policyDetail.expire_date}}</div>
                </div>
            </div>
            <div class="py-4 border-t text-12 font-light text-a-black-484848 leading-4.5">
                <div class="flex justify-between">
                    <div>ประเภทกรมธรรม์</div>
                    <div>{{policyDetail.policy_type}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div class="flex-shrink-0">ชื่อผู้เอาประกันภัย</div>
                    <div class="w-full text-right" v-html="getName(policyDetail.policy_desc.assured)"></div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>ทะเบียน</div>
                    <div>{{policyDetail.policy_desc.register}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>จังหวัด</div>
                    <div>{{policyDetail.policy_desc.province}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>ยี่ห้อ</div>
                    <div>{{policyDetail.policy_desc.brand}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>รุ่น</div>
                    <div>{{policyDetail.policy_desc.model}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>สี</div>
                    <div>{{policyDetail.policy_desc.color}}</div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="pb-2.5">
                <div class="text-16 font-medium text-a-black-555555">ข้อมูลกรมธรรม์</div>
                <div class="pt-4 text-12 text-a-black-484848">{{policyDetail.main_class_name}}</div>
                <div class="flex justify-between pt-1.5 text-12 text-a-black-484848">
                    <div class="flex">
                        <div>เลขที่กรมธรรม์</div>
                        <div class="pl-4">{{policyDetail.policy_no}}</div>
                    </div>
                </div>
            </div>
            <div class="py-4 border-t text-12 font-light text-a-black-484848">
                <div class="flex justify-between">
                    <div>วันที่เริ่มคุ้มครอง</div>
                    <div>{{policyDetail.effective_date}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>วันสิ้นสุดความคุ้มครอง</div>
                    <div>{{policyDetail.expire_date}}</div>
                </div>
            </div>
            <div class="py-4 border-t text-12 font-light text-a-black-484848">
                <div class="flex justify-between">
                    <div>ประเภทกรมธรรม์</div>
                    <div>{{policyDetail.policy_type}}</div>
                </div>
                <div class="flex justify-between pt-2">
                    <div>แผนความคุ้มครอง</div>
                    <div>{{policyDetail.policy_plan}}</div>
                </div>
                <div v-for=" item in policyDetail.policy_desc" :key="item.value" class=" pt-2">
                    <div class="flex">
                        <div class="flex-shrink-0">{{item.label}}</div>
                        <div class="w-full text-right" v-html="getName(item.detail)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useTracking } from "@/feature/TrackingFeature"
import CacheHelper from "@/helper/CacheHelper.js"
import Util from '@/helper/Utility'

export default {
    name: 'PolicyInfo',
    props: {
        policyDetail: Object
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()
        const getName = (name) => {
            return Util.newLineToBr(name)
        }

        return {
            tracking,
            getName,
        }
    },
    created: function() {
        // console.log(this.policyDetail)
    },
    methods: {
        clickClaim: function() {
            this.tracking.event("policy_detail_page", "click_claim_history", "", "");
            this.cache = new CacheHelper('local')
            this.cache.setCache('policyId', this.policyDetail.policy_no)
            this.$router.push('/claim')
        },
    },
}
</script>


